import SingletonEventEmitterClass from "../SingletonEventEmitterClass";
import {fetchPassDispatchOrder} from "../../api/operation/dispatchWorkOrder";
import {FeatureCollection, Point} from "geojson";
import transform from "geojson-transformer";
import {point as createPoint} from "@turf/helpers";
import iziToast from "izitoast";

export default class DispatchWorkOrderLoader extends SingletonEventEmitterClass{
    private _region?: string = undefined;
    public _data: any[] = [];

    public async fetchDispatchOrder(startDate?:string,endDate?:string) {
        const region = localStorage.getItem('gide-region');
        if (region) {
            this._region = region;
            let count = 1000;
            for(let limit=1000,skip=0;skip<=count;skip+=(limit+1)){
                const {data} = await fetchPassDispatchOrder(this._region! as string,limit,skip,startDate,endDate);
                Array.prototype.push.apply(this._data,data.items);

                count = data.count;
                skip--;
                this._triggerUpdate();
            }
            // @ts-ignore
            window.iziToast.success({
                title: '加载完成',
                timeout: 2000
            });
        }
    }

    public clear():void{
        this._data = [];
        this._triggerUpdate();
    }
    public get geojson(): FeatureCollection<Point> {
        return {
            type: 'FeatureCollection',
            features: this._data.map((item: any) => {
                    const coordinates = item.orderId?transform(item.orderId.route.end.lngLat, 'gcj02', 'wgs84'):[];
                    return createPoint(coordinates, {
                        id: item._id,
                        photo: item.photos[0],
                        orderid: item.orderId&&item.orderId._id,
                        createdAt: new Date(item.createdAt).toLocaleString(),
                        creator: item.processor && item.processor.cert && item.processor.cert.name,
                        processed: new Date(item.processedAt).toLocaleString(),
                        info: {...item, layerType: 'dispatchWorkOrder'},
                    },);
            }),
        };
    }

    public onMapLoad() {
        const region = localStorage.getItem('gide-region');
        if (region) {
            this._region = region;
            this.fetchDispatchOrder();
        }
    }

    private _triggerUpdate() {
        this.emit('updated');
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/DispatchWorkOrderLoader.ts